import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-custom-datepicker',
  standalone: false,
  templateUrl: './custom-datepicker.component.html',
  styleUrls: ['./custom-datepicker.component.scss'],
})
export class CustomDatepickerComponent implements OnInit {

  @Input()
  dateControl: UntypedFormControl;

  @Input()
  dateClass: any;

  @Input()
  warningVal: number;

  @Output()
  dateChange: EventEmitter<any>;

  constructor() {
    this.dateChange = new EventEmitter();
  }

  ngOnInit(): void {
  }

}
